import { render, staticRenderFns } from "./ModalOwner.vue?vue&type=template&id=826411b6&"
import script from "./ModalOwner.vue?vue&type=script&lang=js&"
export * from "./ModalOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports